import React from 'react';
import PropTypes from 'prop-types';

export const Active = ({ width, height, ...props }) => (
  <svg
    data-icon='active'
    xmlns='http://www.w3.org/2000/svg'
    width={ width }
    height={ height }
    fill='none'
    viewBox='0 0 24 24'
    { ...props }
  >
    <path
      fill='currentColor'
      d='M12 17c1.383 0 2.563-.488 3.537-1.463C16.512 14.563 17 13.383 17 12s-.488-2.563-1.463-3.537C14.563 7.488 13.383 7 12 7s-2.563.487-3.537 1.463C7.488 9.438 7 10.617 7 12s.487 2.563 1.463 3.537C9.438 16.512 10.617 17 12 17Zm0 5a9.738 9.738 0 0 1-3.9-.788 10.099 10.099 0 0 1-3.175-2.137c-.9-.9-1.612-1.958-2.137-3.175A9.738 9.738 0 0 1 2 12c0-1.383.263-2.683.788-3.9a10.099 10.099 0 0 1 2.137-3.175c.9-.9 1.958-1.612 3.175-2.137A9.738 9.738 0 0 1 12 2c1.383 0 2.683.263 3.9.788a10.098 10.098 0 0 1 3.175 2.137c.9.9 1.613 1.958 2.137 3.175A9.738 9.738 0 0 1 22 12a9.738 9.738 0 0 1-.788 3.9 10.098 10.098 0 0 1-2.137 3.175c-.9.9-1.958 1.613-3.175 2.137A9.738 9.738 0 0 1 12 22Zm0-2c2.233 0 4.125-.775 5.675-2.325C19.225 16.125 20 14.233 20 12c0-2.233-.775-4.125-2.325-5.675C16.125 4.775 14.233 4 12 4c-2.233 0-4.125.775-5.675 2.325C4.775 7.875 4 9.767 4 12c0 2.233.775 4.125 2.325 5.675C7.875 19.225 9.767 20 12 20Z'
    />
  </svg>
);

Active.propTypes = {
  width: PropTypes.number,
  height: PropTypes.number,
};

Active.defaultProps = {
  width: 24,
  height: 24,
};
